<template>
  <v-app>
    <v-card
      class="mt-3"
      v-if="settransactionInvoice.bill_type.bill_type_name == 'ใบแจ้งชำระหนี้'"
    >
      <v-card-title
        style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            background-color: #ffd600;
            padding-left: 50px;
            padding-right: 50px;
          "
        ><div style="color: #262626; font-size: 22px; font-weight: bold">
          ใบแจ้งหนี้/ใบวางบิล
        </div>
        <img
          src="@/assets/back-office/logo.png"
          alt="weserve"
          width="150px"/></v-card-title
      ><v-card-text style="padding-left: 80px; padding-right: 80px">
        <v-layout wrap>
          <v-flex xs12 sm6>
            <v-layout>
              <v-flex xs3 class="body__content__title">ผู้ออก</v-flex>
              <v-layout class="d-block">
                <v-flex xs9 class="body__content__value">{{
                  settransactionInvoice.bill_issuer_name
                }}</v-flex>
                <v-flex xs9 class="body__content__value">{{
                  settransactionInvoice.bill_issuer_address
                }}</v-flex>
              </v-layout>
            </v-layout>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm5>
            <v-layout>
              <v-flex xs5 class="body__content__title"
                >เลขประจำตัวผู้เสียภาษี</v-flex
              >
              <v-flex xs7 class="body__content__value">{{
                settransactionInvoice.bill_issuer_tax_id
              }}</v-flex></v-layout
            ></v-flex
          ></v-layout
        >
        <hr class="new2 my-3" />
        <v-layout wrap>
          <v-flex xs12 sm6>
            <v-layout>
              <v-flex xs5 class="body__content__title">ลูกค้า</v-flex>
              <v-flex xs7 class="body__content__value">{{
                settransactionInvoice.bill_customer_name
              }}</v-flex></v-layout
            >
            <v-layout>
              <v-flex xs5 class="body__content__title">ที่อยู่</v-flex>
              <v-flex xs7 class="body__content__value">{{
                settransactionInvoice.bill_customer_address
              }}</v-flex></v-layout
            >
            <v-layout>
              <v-flex xs5 class="body__content__title"
                >เลขประจำตัวผู้เสียภาษี</v-flex
              >
              <v-flex xs7 class="body__content__value">{{
                settransactionInvoice.bill_customer_tax_id
              }}</v-flex></v-layout
            >
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm5>
            <v-layout>
              <v-flex xs5 class="body__content__title">เลขที่ใบกำกับ</v-flex>
              <v-flex xs7 class="body__content__value">{{
                settransactionInvoice.bill_number
              }}</v-flex></v-layout
            >
            <v-layout>
              <v-flex xs5 class="body__content__title">วันที่ออก</v-flex>
              <v-flex xs7 class="body__content__value">{{
                moment(settransactionInvoice.create_at).format("DD/MM/YYYY")
              }}</v-flex></v-layout
            >
            <v-layout>
              <v-flex xs5 class="body__content__title">ครบกำหนด</v-flex>
              <v-flex xs7 class="body__content__value">{{
                moment(settransactionInvoice.bill_due_date).format("DD/MM/YYYY")
              }}</v-flex></v-layout
            >
          </v-flex></v-layout
        >
        <hr class="my-3" />
        <v-data-table
          hide-actions
          :headers="headers"
          :items="settransactionInvoice.bill_detail"
        >
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-left">
                {{ props.index + 1 }}
              </td>
              <td class="text-xs-left">
                {{ props.item.name }}
              </td>
              <td class="text-xs-left">
                {{ props.item.unit }}
              </td>
              <td class="text-xs-left">
                {{ props.item.price }}
              </td>
              <td class="text-xs-left">
                0.0
              </td>
              <td class="text-xs-left">
                {{ props.item.unit * props.item.price }}
              </td>
            </tr></template
          >
        </v-data-table>
        <v-layout class="mt-3">
          <v-flex
            xs6
            style="display: flex; align-items: flex-end"
            class="body__content__title"
            >ตัวอักษร :
            <span class="body__content__value"
              >({{ settransactionInvoice.bill_net_price_text }}).</span
            ></v-flex
          >
          <v-flex xs6>
            <v-layout wrap>
              <v-flex xs6 class="text-xs-right">รวมเป็นเงิน</v-flex>
              <v-flex xs6 class="body__content__value text-xs-right">{{
                settransactionInvoice.bill_amount_price
              }}</v-flex>
              <v-flex xs6 class="text-xs-right"
                ><span style="text-decoration: underline">หัก</span>
                ส่วนลด</v-flex
              >
              <v-flex xs6 class="body__content__value text-xs-right">{{
                settransactionInvoice.bill_discount_price
              }}</v-flex>
              <v-flex xs6 class="text-xs-right">ยอดหลังหักส่วนลด</v-flex>
              <v-flex xs6 class="body__content__value text-xs-right">{{
                settransactionInvoice.bill_amount_price -
                  settransactionInvoice.bill_discount_price
              }}</v-flex
              ><v-flex xs6 class="text-xs-right"
                ><span style="text-decoration: underline">หัก</span>
                เงินมัดจำ</v-flex
              >
              <v-flex xs6 class="body__content__value text-xs-right">{{
                settransactionInvoice.bill_deposit_price
              }}</v-flex>
              <v-flex xs6 class="text-xs-right">จำนวนเงินหลังหักมัดจำ</v-flex>
              <v-flex xs6 class="body__content__value text-xs-right">{{
                settransactionInvoice.bill_amount_price -
                  settransactionInvoice.bill_discount_price -
                  settransactionInvoice.bill_deposit_price
              }}</v-flex>
              <v-flex xs6 class="text-xs-right">จำนวนภาษีมูลค่าเพิ่ม 7%</v-flex>
              <v-flex xs6 class="body__content__value text-xs-right">{{
                settransactionInvoice.bill_vat_price
              }}</v-flex>
              <v-flex xs6 class="text-xs-right body__content__title"
                >จำนวนเงินรวมทั้งสิ้น</v-flex
              >
              <v-flex xs6 class="body__content__title text-xs-right">{{
                settransactionInvoice.bill_net_price
              }}</v-flex>
            </v-layout></v-flex
          ></v-layout
        >
      </v-card-text></v-card
    >
    <v-card class="mt-3" v-else>
      <v-card-title
        style="
            display: flex;
            align-items: center;
            justify-content: space-between;
            background-color: #ffd600;
            padding-left: 50px;
            padding-right: 50px;
          "
        ><div style="color: #262626; font-size: 22px; font-weight: bold">
          ใบแจ้งชำระหนี้ของ RIDER
        </div>
        <img
          src="@/assets/back-office/logo.png"
          alt="weserve"
          width="150px"/></v-card-title
      ><v-card-text style="padding-left: 80px; padding-right: 80px">
        <v-layout wrap>
          <v-flex xs12 sm6>
            <v-layout>
              <v-flex xs3 class="body__content__title">ผู้ออก</v-flex>
              <v-layout class="d-block">
                <v-flex xs9 class="body__content__value">{{
                  settransactionInvoice.bill_issuer_name
                }}</v-flex>
                <v-flex xs9 class="body__content__value">{{
                  settransactionInvoice.bill_issuer_address
                }}</v-flex>
              </v-layout>
            </v-layout>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm5>
            <v-layout>
              <v-flex xs5 class="body__content__title"
                >เลขประจำตัวผู้เสียภาษี</v-flex
              >
              <v-flex xs7 class="body__content__value">{{
                settransactionInvoice.bill_issuer_tax_id
              }}</v-flex></v-layout
            ></v-flex
          ></v-layout
        >
        <hr class="new2 my-3" />
        <v-layout wrap>
          <v-flex xs12 sm6>
            <v-layout>
              <v-flex xs5 class="body__content__title">ลูกค้า</v-flex>
              <v-flex xs7 class="body__content__value">{{
                settransactionInvoice.bill_customer_name
              }}</v-flex></v-layout
            >
            <v-layout>
              <v-flex xs5 class="body__content__title">ที่อยู่</v-flex>
              <v-flex xs7 class="body__content__value">{{
                settransactionInvoice.bill_customer_address
              }}</v-flex></v-layout
            >
            <v-layout>
              <v-flex xs5 class="body__content__title"
                >เลขประจำตัวผู้เสียภาษี</v-flex
              >
              <v-flex xs7 class="body__content__value">{{
                settransactionInvoice.bill_customer_tax_id
              }}</v-flex></v-layout
            >
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 sm5>
            <v-layout>
              <v-flex xs5 class="body__content__title">เลขที่ใบกำกับ</v-flex>
              <v-flex xs7 class="body__content__value">{{
                settransactionInvoice.bill_number
              }}</v-flex></v-layout
            >
            <v-layout>
              <v-flex xs5 class="body__content__title">วันที่ออก</v-flex>
              <v-flex xs7 class="body__content__value">{{
                moment(settransactionInvoice.create_at).format("DD/MM/YYYY")
              }}</v-flex></v-layout
            >
            <v-layout>
              <v-flex xs5 class="body__content__title">ครบกำหนด</v-flex>
              <v-flex xs7 class="body__content__value">{{
                moment(settransactionInvoice.bill_due_date).format("DD/MM/YYYY")
              }}</v-flex></v-layout
            >
          </v-flex></v-layout
        >
        <hr class="my-3" />
        <v-data-table
          hide-actions
          :headers="headers"
          :items="settransactionInvoice.bill_detail"
        >
          <template v-slot:items="props">
            <tr>
              <td class="text-xs-left">
                {{ props.index + 1 }}
              </td>
              <td class="text-xs-left">
                {{ props.item.name }}
              </td>
              <td class="text-xs-left">
                {{ props.item.unit }}
              </td>
              <td class="text-xs-left">
                {{ props.item.price }}
              </td>
              <td class="text-xs-left">
                0.0
              </td>
              <td class="text-xs-left">
                {{ props.item.unit * props.item.price }}
              </td>
            </tr></template
          >
        </v-data-table>
        <v-layout style="margin-top:10vh">
          <v-flex
            xs6
            style="display: flex; align-items: flex-end"
            class="body__content__title"
            >ตัวอักษร :
            <span class="body__content__value"
              >({{ settransactionInvoice.bill_net_price_text }}).</span
            ></v-flex
          >
          <v-flex xs6>
            <v-layout wrap>
              <v-flex xs6 class="text-xs-right">รวมเป็นเงินทั้งสิ้น</v-flex>
              <v-flex xs6 class="body__content__value text-xs-right">
                {{ settransactionInvoice.bill_amount_price }}
              </v-flex>
            </v-layout></v-flex
          ></v-layout
        >
      </v-card-text></v-card
    >
  </v-app>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      headers: [
        { text: "ลำดับที่", value: "index + 1" },
        { text: "รายละเอียด", value: "name" },
        { text: "จำนวน", value: "unit" },
        { text: "หน่อยละ", value: "carbs" },
        { text: "ส่วนลด", value: "protein" },
        { text: "จำนวนเงิน", value: "iron" },
      ],
    };
  },
  computed: {
    ...mapState({
      settransactionInvoice: (state) =>
        state.fetchUserBack.settransactionInvoice,
    }),
  },
  methods: {
    ...mapActions({
      fetchtransactionInvoiceBill: "fetchUserBack/fetchtransactionInvoice",
    }),
    async getDataInvoice() {
      let idinvoice = this.$route.params.transaction_partner_id;
      this.loadingMessage = true;
      await this.fetchtransactionInvoiceBill({
        invoice_id: idinvoice,
      });
      this.loadingMessage = false;
    },
  },
  created() {
    this.getDataInvoice();
  },
};
</script>
